(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('react-dom'), require('prop-types')) :
	typeof define === 'function' && define.amd ? define(['react', 'react-dom', 'prop-types'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global["dist/index"] = global["dist/index"] || {}, global["dist/index"].js = factory(global.React, global.ReactDOM, global.PropTypes)));
})(this, (function (React, reactDom, require$$1) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	var require$$1__default = /*#__PURE__*/_interopDefaultLegacy(require$$1);

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	var dist = {exports: {}};

	(function (module, exports) {
	(function (global, factory) {
	    module.exports = factory(React__default["default"], require$$1__default["default"]) ;
	})(commonjsGlobal, (function (React, PropTypes) {
	    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	    var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

	    var _assign = function __assign() {
	      _assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	      };
	      return _assign.apply(this, arguments);
	    };
	    function __rest(s, e) {
	      var t = {};
	      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	      if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	      }
	      return t;
	    }

	    var CloseIcon = function (_a) {
	        var _b = _a.color, color = _b === void 0 ? '#004C60' : _b, _c = _a.width, width = _c === void 0 ? '1rem' : _c, _d = _a.height, height = _d === void 0 ? '1rem' : _d;
	        return (React__default["default"].createElement("svg", { width: width, height: height, viewBox: '0 0 12 12', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	            React__default["default"].createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M0.200196 0.200196C0.467125 -0.0667321 0.899902 -0.0667321 1.16683 0.200196L6.00001 5.03337L10.8332 0.200216C11.1001 -0.0667123 11.5329 -0.0667123 11.7998 0.200216C12.0667 0.467144 12.0667 0.89992 11.7998 1.16685L6.96664 6L11.7998 10.8332C12.0667 11.1001 12.0667 11.5329 11.7998 11.7998C11.5329 12.0667 11.1001 12.0667 10.8332 11.7998L6.00001 6.96663L1.16683 11.7998C0.899903 12.0667 0.467126 12.0667 0.200198 11.7998C-0.0667308 11.5329 -0.0667308 11.1001 0.200198 10.8332L5.03338 6L0.200196 1.16683C-0.0667322 0.8999 -0.0667322 0.467124 0.200196 0.200196Z', fill: color })));
	    };

	    function styleInject(css, ref) {
	      if (ref === void 0) ref = {};
	      var insertAt = ref.insertAt;
	      if (!css || typeof document === 'undefined') {
	        return;
	      }
	      var head = document.head || document.getElementsByTagName('head')[0];
	      var style = document.createElement('style');
	      style.type = 'text/css';
	      if (insertAt === 'top') {
	        if (head.firstChild) {
	          head.insertBefore(style, head.firstChild);
	        } else {
	          head.appendChild(style);
	        }
	      } else {
	        head.appendChild(style);
	      }
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(document.createTextNode(css));
	      }
	    }

	    var css_248z$5 = "/* Consolidation of frequently used colours throughout the repo */\n.close_button {\n  display: flex;\n  padding: 0.5rem;\n  border: 0;\n  background-color: transparent;\n}\n.close_button:focus {\n  outline: 2px solid #004c60;\n  border-radius: 0.313rem;\n}";
	    styleInject(css_248z$5);

	    var CloseButton = function (_a) {
	        var iconProps = _a.iconProps, className = _a.className, rest = __rest(_a, ["iconProps", "className"]);
	        return (React__default["default"].createElement("button", _assign({ "data-testid": 'close_btn', className: "close_button ".concat(typeof className === 'string' ? className : ''), type: 'button' }, rest),
	            React__default["default"].createElement(CloseIcon, _assign({}, iconProps))));
	    };

	    var css_248z$4 = ".dialog_title {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin: 0 2rem 2rem;\n}";
	    styleInject(css_248z$4);

	    var DialogTitle = function (_a) {
	        var onClose = _a.onClose, children = _a.children, _b = _a.displayCrossButton, displayCrossButton = _b === void 0 ? true : _b;
	        return (React__default["default"].createElement("div", { className: 'dialog_title' },
	            React__default["default"].createElement("div", null,
	                React__default["default"].createElement("h1", null, children)),
	            onClose && displayCrossButton && React__default["default"].createElement(CloseButton, { onClick: onClose })));
	    };

	    var css_248z$3 = "/* Consolidation of frequently used colours throughout the repo */\n.primary_button {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #ffffff;\n  background: #051d33;\n  border: 1px solid transparent;\n}\n.primary_button span {\n  text-align: center;\n}\n.primary_button[disabled] {\n  background: #eeeeee;\n  border: 1px solid #c3c3c3;\n  color: #6b6b6b !important;\n  pointer-events: none;\n}\n.primary_button:hover {\n  background: #024055;\n  border: 1px solid #051d33;\n}\n.primary_button:focus {\n  background: #024055;\n  border: 1px solid #051d33;\n}\n.primary_button:active {\n  border: 1px solid #051d33;\n}\n.primary_button .icon {\n  padding-right: 10px;\n}\n\n.primary_button_outline {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #051d33;\n  background: #ffffff;\n  border: 1px solid #051d33;\n}\n.primary_button_outline span {\n  text-align: center;\n}\n.primary_button_outline[disabled] {\n  background: #eeeeee;\n  border: 1px solid #c3c3c3;\n  color: #6b6b6b !important;\n  pointer-events: none;\n}\n.primary_button_outline:hover {\n  background: #f3fafd;\n  border: 1px solid #17a2b8;\n}\n.primary_button_outline:focus {\n  border: 1px solid #6dc7be;\n}\n.primary_button_outline:active {\n  border: 1px solid #051d33;\n  color: #051d33;\n}\n.primary_button_outline .icon {\n  padding-right: 10px;\n}\n\n.primary_button_outline_danger {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #ab1212;\n  background: #ffffff;\n  border: 1px solid #ab1212;\n}\n.primary_button_outline_danger span {\n  text-align: center;\n}\n.primary_button_outline_danger[disabled] {\n  background: #eeeeee;\n  border: 1px solid #c3c3c3;\n  color: #6b6b6b !important;\n  pointer-events: none;\n}\n.primary_button_outline_danger:hover {\n  background: #f3fafd;\n  border: 1px solid #dc3545;\n  color: #dc3545 !important;\n}\n.primary_button_outline_danger:focus {\n  border: 1px solid #dc3545;\n  color: #dc3545 !important;\n}\n.primary_button_outline_danger:active {\n  border: 1px solid #051d33;\n}\n.primary_button_outline_danger .icon {\n  padding-right: 10px;\n}";
	    styleInject(css_248z$3);

	    var PrimaryButton = function (_a) {
	        var style = _a.style, _b = _a.clickHandler, clickHandler = _b === void 0 ? function () { return null; } : _b, isDisabled = _a.isDisabled, children = _a.children, title = _a.title, type = _a.type, variant = _a.variant, _c = _a.delay, delay = _c === void 0 ? 1000 : _c, ariaLabel = _a.ariaLabel, buttonProps = __rest(_a, ["style", "clickHandler", "isDisabled", "children", "title", "type", "variant", "delay", "ariaLabel"]);
	        var _d = React.useState(false), isClicked = _d[0], setIsClicked = _d[1];
	        React.useEffect(function () {
	            var timer;
	            if (isClicked) {
	                timer = setTimeout(function () {
	                    setIsClicked(false);
	                }, delay);
	            }
	            return function () { return clearTimeout(timer); };
	        }, [isClicked]);
	        var class_name = variant === ''
	            ? 'primary_button'
	            : variant === 'outline'
	                ? 'primary_button_outline'
	                : 'primary_button_outline_danger';
	        var handleClick = function () {
	            if (!isClicked) {
	                setIsClicked(true);
	                clickHandler();
	            }
	        };
	        return (
	        // eslint-disable-next-line react/button-has-type
	        React__default["default"].createElement("button", _assign({ "data-testid": 'primary_button', "aria-label": type, type: type, className: class_name, style: style, onClick: handleClick, disabled: isDisabled, title: ariaLabel }, buttonProps),
	            children && React__default["default"].createElement("span", { className: 'icon' }, children),
	            " ",
	            React__default["default"].createElement("span", null, title),
	            ' '));
	    };
	    PrimaryButton.propTypes = {
	        style: PropTypes__default["default"].object,
	        type: PropTypes__default["default"].oneOf(['button', 'submit', 'reset']),
	        clickHandler: PropTypes__default["default"].func,
	        title: PropTypes__default["default"].any.isRequired,
	        isDisabled: PropTypes__default["default"].bool,
	        children: PropTypes__default["default"].any,
	        variant: PropTypes__default["default"].oneOf(['', 'outline', 'danger']),
	        delay: PropTypes__default["default"].number,
	        ariaLabel: PropTypes__default["default"].string,
	    };
	    PrimaryButton.defaultProps = {
	        style: {},
	        type: 'button',
	        clickHandler: function () { return null; },
	        isDisabled: false,
	        children: '',
	        variant: '',
	        delay: 1000,
	        ariaLabel: '',
	    };

	    var css_248z$2 = "/* Consolidation of frequently used colours throughout the repo */\n.dialog_action {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  border-top: 1px solid #c3c3c3;\n  padding: 1.5rem 2rem;\n  background-color: #fafafa;\n  gap: 1rem;\n}\n.dialog_action button.primary_button {\n  color: #051d33;\n  background-color: #ffb600;\n  border: 2px solid #ffb600;\n}\n.dialog_action button.primary_button:hover {\n  background-color: #ffc944;\n  border: 2px solid #ffc944;\n}\n.dialog_action button.primary_button[disabled=disabled], .dialog_action button.primary_button:disabled {\n  background-color: #c3c3c3 !important;\n  border: 2px solid #c3c3c3 !important;\n  cursor: default !important;\n}";
	    styleInject(css_248z$2);

	    var DialogAction = function (_a) {
	        var primaryButtonConfig = _a.primaryButtonConfig, secondaryButtonConfig = _a.secondaryButtonConfig, children = _a.children;
	        var showSecondaryButton = (secondaryButtonConfig === null || secondaryButtonConfig === void 0 ? void 0 : secondaryButtonConfig.title) && typeof (secondaryButtonConfig === null || secondaryButtonConfig === void 0 ? void 0 : secondaryButtonConfig.clickHandler) === 'function';
	        var showPrimaryButton = (primaryButtonConfig === null || primaryButtonConfig === void 0 ? void 0 : primaryButtonConfig.title) && typeof (primaryButtonConfig === null || primaryButtonConfig === void 0 ? void 0 : primaryButtonConfig.clickHandler) === 'function';
	        return (React__default["default"].createElement(React__default["default"].Fragment, null, children || (React__default["default"].createElement("div", { className: 'dialog_action' },
	            showSecondaryButton && React__default["default"].createElement(PrimaryButton, _assign({ variant: 'outline' }, secondaryButtonConfig)),
	            showPrimaryButton && React__default["default"].createElement(PrimaryButton, _assign({}, primaryButtonConfig))))));
	    };

	    var css_248z$1 = "/* Consolidation of frequently used colours throughout the repo */\n.dialog_content {\n  display: flex;\n  flex: 1 1 auto;\n  padding: 0 2rem 2rem;\n  overflow-y: auto;\n  flex-direction: column;\n}\n.dialog_content::-webkit-scrollbar {\n  width: 0.625rem;\n  border-left: 1px solid #eeeeee;\n}\n.dialog_content::-webkit-scrollbar-thumb {\n  background-color: #004c60;\n  border-radius: 0.625rem;\n  border: 1px solid white;\n}";
	    styleInject(css_248z$1);

	    var DialogContent = function (_a) {
	        var children = _a.children;
	        return React__default["default"].createElement("div", { className: 'dialog_content' }, children);
	    };

	    var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.dialog {\n  background-color: #ffffff;\n  box-shadow: -9px 0 18px 0 rgba(0, 0, 0, 0.1215686275);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding-top: 2rem;\n}\n.dialog h1 {\n  letter-spacing: 0;\n  color: #051d33;\n  margin: 0;\n  font-weight: 750;\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n.dialog h3 {\n  letter-spacing: 0;\n  color: #051d33;\n  margin: 0;\n  font-weight: 750;\n  font-size: 1.125rem;\n  line-height: 1.625rem;\n}\n.dialog.md {\n  width: 592px;\n}\n.dialog.full {\n  width: 100%;\n}\n.dialog.center {\n  max-height: calc(100vh - 6rem);\n  overflow: hidden;\n}\n\n@media screen and (max-width: 767px) {\n  .dialog.md {\n    width: 100%;\n    height: 100%;\n    max-height: 100%;\n  }\n}";
	    styleInject(css_248z);

	    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
	    var Dialog = function (_a) {
	        var title = _a.title, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.position, position = _c === void 0 ? 'center' : _c, onClose = _a.onClose, primaryButtonConfig = _a.primaryButtonConfig, secondaryButtonConfig = _a.secondaryButtonConfig, onClick = _a.onClick, children = _a.children, displayCrossButton = _a.displayCrossButton, id = _a.id;
	        var dialogRef = React.useRef(null);
	        var dummyRef = React.useRef(null);
	        var handleTab = function (event) {
	            var _a;
	            if (event.key === 'Tab' && dummyRef.current === document.activeElement) {
	                (_a = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _a === void 0 ? void 0 : _a.focus();
	            }
	        };
	        React.useEffect(function () {
	            var _a;
	            window.addEventListener('keydown', handleTab);
	            (_a = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _a === void 0 ? void 0 : _a.focus();
	            return function () {
	                window.removeEventListener('keydown', handleTab);
	            };
	        }, []);
	        var showActionContainer = (primaryButtonConfig === null || primaryButtonConfig === void 0 ? void 0 : primaryButtonConfig.title) ||
	            typeof (primaryButtonConfig === null || primaryButtonConfig === void 0 ? void 0 : primaryButtonConfig.clickHandler) === 'function' ||
	            (secondaryButtonConfig === null || secondaryButtonConfig === void 0 ? void 0 : secondaryButtonConfig.title) ||
	            typeof (secondaryButtonConfig === null || secondaryButtonConfig === void 0 ? void 0 : secondaryButtonConfig.clickHandler) === 'function';
	        var handleClick = function (e) {
	            e.stopPropagation();
	            if (typeof onClick === 'function') {
	                onClick(e);
	            }
	        };
	        var handleKeyDown = function (event) {
	            if (event.key === 'Enter') {
	                handleClick(event);
	            }
	        };
	        return (React__default["default"].createElement("div", { className: "dialog ".concat(typeof size === 'string' ? size : '', " ").concat(typeof position === 'string' ? position : ''), "data-testid": 'dialog', onClick: handleClick, onKeyDown: handleKeyDown, tabIndex: typeof onClick === 'function' ? 0 : -1, role: 'dialog', "aria-modal": 'true', id: id, ref: dialogRef },
	            title && (React__default["default"].createElement(DialogTitle, { onClose: onClose, displayCrossButton: displayCrossButton }, title)),
	            children && React__default["default"].createElement(DialogContent, null, children),
	            showActionContainer && (React__default["default"].createElement(DialogAction, { primaryButtonConfig: primaryButtonConfig, secondaryButtonConfig: secondaryButtonConfig })),
	            React__default["default"].createElement("div", { tabIndex: 0, ref: dummyRef, id: 'focus_dummy' })));
	    };

	    return Dialog;

	}));
	}(dist));

	var Dialog = dist.exports;

	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}

	var css_248z$2 = ".overlay {\n  position: fixed;\n  z-index: 1000;\n  inset: 0;\n}";
	styleInject(css_248z$2);

	var Overlay = function (_a) {
	    var children = _a.children;
	    return (React__default["default"].createElement("div", { "data-testid": 'overlay', role: 'presentation', "aria-hidden": 'true', className: 'overlay' }, children));
	};

	var _assign = function __assign() {
	  _assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	      s = arguments[i];
	      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	  };
	  return _assign.apply(this, arguments);
	};
	function __rest(s, e) {
	  var t = {};
	  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	}

	var css_248z$1 = ".backdrop {\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  inset: 0;\n  background-color: rgba(5, 29, 51, 0.5);\n  -webkit-tap-highlight-color: transparent;\n  z-index: -1;\n}\n.backdrop.left {\n  justify-content: flex-start;\n  align-items: stretch;\n}\n.backdrop.center {\n  justify-content: center;\n}\n.backdrop.right {\n  justify-content: flex-end;\n  align-items: stretch;\n}";
	styleInject(css_248z$1);

	var Backdrop = function (_a) {
	    var position = _a.position, children = _a.children, rest = __rest(_a, ["position", "children"]);
	    return (React__default["default"].createElement("div", _assign({ "data-testid": 'backdrop', "aria-hidden": 'true', className: "backdrop ".concat(typeof position === 'string' ? position : '') }, rest), children));
	};

	var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.dialog {\n  box-shadow: -9px 0 18px 0 rgba(0, 0, 0, 0.1215686275);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding-top: 2rem;\n}\n.dialog h1 {\n  letter-spacing: 0;\n  color: #051d33;\n  margin: 0;\n  font-weight: 750;\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n.dialog h3 {\n  letter-spacing: 0;\n  color: #051d33;\n  margin: 0;\n  font-weight: 750;\n  font-size: 1.125rem;\n  line-height: 1.625rem;\n}";
	styleInject(css_248z);

	var ResponsiveModal = function (_a) {
	    var show = _a.show, title = _a.title, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.position, position = _c === void 0 ? 'center' : _c, onClose = _a.onClose, primaryButtonConfig = _a.primaryButtonConfig, secondaryButtonConfig = _a.secondaryButtonConfig, _d = _a.closeOnBackdropClick, closeOnBackdropClick = _d === void 0 ? true : _d, _e = _a.usePortal, usePortal = _e === void 0 ? true : _e, children = _a.children, displayCrossButton = _a.displayCrossButton, id = _a.id;
	    var renderModal = function () { return (React__default["default"].createElement(Overlay, null,
	        React__default["default"].createElement(Backdrop, { position: position, onClick: closeOnBackdropClick ? onClose : undefined },
	            React__default["default"].createElement(Dialog, { title: title, size: size, position: position, onClose: onClose, primaryButtonConfig: primaryButtonConfig, secondaryButtonConfig: secondaryButtonConfig, className: 'dialog', displayCrossButton: displayCrossButton, id: id }, children)))); };
	    return (React__default["default"].createElement(React__default["default"].Fragment, null,
	        show && usePortal && reactDom.createPortal(renderModal(), document.body, 'modal'),
	        show && !usePortal && renderModal()));
	};

	return ResponsiveModal;

}));
